import ModalCadastro from "../../../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalInformacao from "../../../../../components/ModalInformacao/ModalInformacao.tsx";
import ModalImage from "../../../../../core/data-display/ModalImage.tsx";
import ModalEncontrarVeiculoIa from "../components/ModalEncontrarVeiculoIa/ModalEncontrarVeiculoIa.tsx";

function ModaisCadastroViagem({
	openCadastroPedido,
	idAtual,
	disable,
	handleCloseCadastroPedido,
	openCadastroUnidadeEmbarque,
	handleCloseCadastroUnidadeEmbarque,
	openCadastroFilial,
	handleCloseCadastroFilial,
	openCadastroEmpresa,
	handleCloseCadastroEmpresa,
	openCadastroVeiculo,
	handleCloseCadastroVeiculo,
	openCadastroMercadoria,
	handleCloseCadastroMercadoria,
	openCadastroEmbalagem,
	handleCloseCadastroEmbalagem,
	openCadastroStatus,
	handleCloseCadastroStatus,
	openCadastroCliente,
	handleCloseCadastroCliente,
	openCadastroMotivo,
	handleCloseCadastroMotivo,
	openCadastroMeioPagamento,
	handleCloseCadastroMeioPagamento,
	open,
	isOpenModalImage,
	selectedImage,
	pedidoId,
	previsaoEmbarque,
	openModalEncontrarVeiculo,
	handleCloseEncontrarVeiculoIa,
	placaCavalo,
	setIsOpenModalImage,
}) {
	return (
		<>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroPedido="sim"
				open={openCadastroPedido}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroPedido}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroUnidadeEmbarque="sim"
				open={openCadastroUnidadeEmbarque}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroUnidadeEmbarque}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroFilial="sim"
				open={openCadastroFilial}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroFilial}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroEmpresaSub="sim"
				open={openCadastroEmpresa}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroEmpresa}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroVeiculo="sim"
				open={openCadastroVeiculo}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroVeiculo}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroMercadoria="sim"
				open={openCadastroMercadoria}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroMercadoria}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroEmbalagem="sim"
				open={openCadastroEmbalagem}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroEmbalagem}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroStatus="sim"
				open={openCadastroStatus}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroStatus}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroCliente="sim"
				open={openCadastroCliente}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroCliente}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroMotivo="sim"
				open={openCadastroMotivo}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroMotivo}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroMeioPagamento="sim"
				open={openCadastroMeioPagamento}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroMeioPagamento}
			/>
			<ModalInformacao open={open} />
			<ModalImage
				isOpen={isOpenModalImage}
				onClose={() => setIsOpenModalImage(false)}
				image={selectedImage}
			/>
			<ModalEncontrarVeiculoIa
				pedidoId={pedidoId}
				previsaoEmbarque={previsaoEmbarque}
				open={openModalEncontrarVeiculo}
				onClose={handleCloseEncontrarVeiculoIa}
				currentPlacaId={placaCavalo || null}
			/>
		</>
	);
}

export default ModaisCadastroViagem;
